// @generated by protoc-gen-connect-query v2.0.0 with parameter "import_extension=js"
// @generated from file services/management/api/tenant_plan.proto (package gx.management.api, syntax proto3)
/* eslint-disable */

import { TenantPlanService } from "./tenant_plan_pb.js";

/**
 * @generated from rpc gx.management.api.TenantPlanService.GetTenantPlan
 */
export const getTenantPlan = TenantPlanService.method.getTenantPlan;

/**
 * @generated from rpc gx.management.api.TenantPlanService.GetTenantUsage
 */
export const getTenantUsage = TenantPlanService.method.getTenantUsage;
